import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { CONFIG } from '../../../core/config';
import { ConfigService } from '../../../core/config.service';
import { LicensingService } from '../../../core/licensing/licensing.service';
import { SpinnerService } from '../../../core/spinner/spinner.service';
import { DashboardService } from '../../../views/dashboard/dashboard.service';


@Component({
  selector: 'hb-app-catalogerror',
  templateUrl: './catalogerror.component.html',
  styleUrls: ['./catalogerror.component.scss']
})
export class CatalogerrorComponent implements OnInit {
  private selectedCatalog: string;
  public emptyCatalog: boolean = false;
  public email: string;

  constructor(private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    private dashboardService: DashboardService,
    private licenseService: LicensingService,
    private spinner: SpinnerService) {

  }

  ngOnInit() {
    const lstCatalog = this.configService.userCatalogs.getValue();
    if (lstCatalog && lstCatalog.length == 0) {
      this.emptyCatalog = true;
      this.email = this.authService.userName;
    }
  }

  setCatalog(val) {
    this.selectedCatalog = val.value.catalogName
  }

  Submit() {
    this.spinner.show();
    this.authService.setCatalog(this.selectedCatalog);
    this.authService.setpermissions();
    this.licenseService.getCurrentLicence();
    this.dashboardService.initialiseDashboardData();
    this.configService.IsError.next(false);
    this.spinner.hide();
    this.router.navigateByUrl(this.authService.urlCatalog + CONFIG.routes.dashboard);
  }
}
